import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from 'utils/classnames';
import { DISPOSITION_COLORS } from 'utils/constants';
import { ArrivalReceipt } from 'types';

interface Props {
  result: ArrivalReceipt;
  scanInput: ReactNode;
  dispositionSheet?: ReactNode;
}

export const ReceivingGradingScreen = ({ result, scanInput, dispositionSheet }: Props) => {
  const { t } = useTranslation();
  const colors = DISPOSITION_COLORS.GRADING;

  return (
    <div
      className={cn(
        '-mx-4 -mb-6 flex min-h-full flex-col items-center px-6 pb-6 pt-4',
        colors.gradient
      )}
    >
      <div className="mb-6 w-full">{scanInput}</div>

      <div className="mb-4 text-center">
        <p className="text-6xl font-black uppercase tracking-widest text-white leading-none">
          {t('receivingGrading.title')}
        </p>
        {result.arrival_disposition && (
          <p className="my-2 text-5xl font-bold uppercase tracking-wide text-white/70">
            {result.arrival_disposition}
          </p>
        )}
      </div>

      <h1 className="mb-4 text-base font-bold text-white">
        {t('receivingGrading.trackingPrefix')} {result.tracking_id}
      </h1>

      <div className="flex flex-col items-center gap-6 text-center my-4">
        <div className="animate-pulse">
          <div
            className={cn(
              'flex h-28 w-28 items-center justify-center rounded-full bg-white/20 ring-4 ring-white/40 ring-offset-2',
              colors.ringOffset
            )}
          >
            <span className="text-6xl">{colors.icon}</span>
          </div>
        </div>
      </div>

      {dispositionSheet}
    </div>
  );
};
